import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import Button from '../../components/Button/Button';
import InputForm from '../../components/InputForm/InputForm';
import Input from '../../components/Input/Input';
import MuiTable from '../../components/MuiTable/MuiTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { StateProps } from '../../redux/reducer';
import { errorMessageAutoCapitalize } from '../../config/helpers';
import Dailog from '../../components/Dailog/Dailog';
import { Role } from '../../config/enum';
import { errorMessage } from '../../config/errorsMsg';
import { successMessage } from '../../config/keyword';

type LabelResponseProps = {
  name: string;
  organizationId: string;
  id: string;
};

const columns = [
  {
    id: 'name',
    label: 'Label',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'categoryCount',
    label: 'Category Count(s)',
    minWidth: 140,
    align: 'center',
  },
  { id: 'action', label: 'Action', minWidth: 0, align: 'right' },
];

const CategoryLabel = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [categoryLable, setCategoryLable] = useState('');
  const [catState, setCatState] = useState('');
  const [addOrUpdate, setAddOrUpdate] = useState({
    heading: 'Add New',
    buttonText: '',
  });
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [state, setState] = useState<LabelResponseProps[]>([]);
  const [categoryLableId, setCategoryLableId] = useState<string>();
  useEffect(() => {
    const breadcrumb = [
      { path: '/categories', name: 'Categories' },
      { path: `/categoryLabel`, name: 'Labels' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getCategoryLabel();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      if (addOrUpdate.heading === 'Add New') {
        addCategory();
      } else if (addOrUpdate.heading === 'Update') {
        updateCategoryLabel();
      }
    }
  }, [formError]);

  const validation = () => {
    const error: any = {};
    if (!categoryLable) {
      error.categoryLable = errorMessage.emptyCategoryLabel;
    } else if (categoryLable.length < 2 || categoryLable.length >= 32) {
      error.categoryLable = errorMessage.categoryLabelLength;
    }
    return error;
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setAddOrUpdate({ ...addOrUpdate, heading: '' });
    setFormError({});
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setCategoryLable(event.target.value);
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const getCategoryLabel = () => {
    dispatch(updateIsLoading(true));
    instance
      .get(`/category-labels`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: LabelResponseProps[]) => {
    setState(data);
    dispatch(updateIsLoading(false));
  };

  const addCategory = () => {
    const obj = {
      name: categoryLable,
      organizationId: userInfo.organizationId,
    };
    dispatch(updateIsLoading(true));
    instance
      .post(`/category-labels`, obj)
      .then((response) => {
        if (response.status === 201) {
          setIsFormOpen(false);
          getCategoryLabel();
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_LABEL_ADD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
    dispatch(updateIsLoading(false));
  };

  const deleteCategoryLabel = async () => {
    await instance
      .delete(`/category-labels/${categoryLableId}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_LABEL_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));

          setIsDeletePopup(false);
          getCategoryLabel();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const deleteRecord = (row: LabelResponseProps) => {
    setCategoryLableId(row.id as string);
    setIsDeletePopup(true);
    setIsFormOpen(false);
  };

  const editRecord = async (row: LabelResponseProps) => {
    dispatch(updateIsLoading(true));
    setFormError({});
    setIsSubmit(false);
    setIsFormOpen(true);
    setCategoryLableId(row.id);
    setAddOrUpdate({ ...addOrUpdate, heading: 'Update', buttonText: 'update' });
    await instance
      .get(`category-labels/${row.id}`)
      .then((response) => {
        if (response.status === 200) {
          setCategoryLable(response.data.name);
          setCatState(response.data.name);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const updateCategoryLabel = async () => {
    const obj = {
      name: categoryLable,
    };
    dispatch(updateIsLoading(true));
    await instance
      .put(`/category-labels/${categoryLableId}`, obj)
      .then((response) => {
        if (response.status === 200) {
          getCategoryLabel();
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_LABEL_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsFormOpen(false);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  return (
    <>
      <div className="p-2">
        <PageHeading label="Manage Labels" />
        <div className="bg-white p-2 rounded-sm">
          <div className="lg:flex items-center justify-end lg:space-y-1 mb-3">
            {userInfo.role !== Role.User && (
              <div className="mt-1">
                <Button
                  label="Add"
                  type="button"
                  buttonType="primary"
                  icon={<i className="fa-solid fa-plus"></i>}
                  onClick={() => {
                    setIsFormOpen(!isFormOpen);
                    setAddOrUpdate({
                      ...addOrUpdate,
                      heading: 'Add New',
                      buttonText: 'submit',
                    });
                    setCategoryLable('');
                  }}
                />
              </div>
            )}
          </div>

          <InputForm
            title={addOrUpdate.heading + ` Label`}
            isFormOpen={isFormOpen}
            onSubmit={onSubmit}
            onCancel={onCancel}
            ButtonText={addOrUpdate.buttonText}
            disabled={
              addOrUpdate.heading === 'Update' ? catState === categoryLable : false
            }
          >
            <div className="lg:flex items-center justify-between">
              <Input
                name={'categoryLable'}
                value={categoryLable}
                type={'text'}
                label={'Label'}
                placeholder={`Enter Label`}
                onChange={handleChange}
                error={formError?.categoryLable}
              />
            </div>
          </InputForm>
          <div className="mt-1">
            <MuiTable
              columns={
                userInfo.role === Role.User
                  ? columns.filter((item) => item.id !== 'action')
                  : columns
              }
              rows={state}
              showEdit={true}
              showDelete={true}
              onEditHanlder={editRecord}
              onDeleteHandler={deleteRecord}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Category Label'}
          onConfirm={deleteCategoryLabel}
        />
      </div>
    </>
  );
};

export default CategoryLabel;
